import { usePublishRoutingConfigVersionMutation } from '../api';
import { GENERIC_PUBLISH_ERROR, parseConfigPathErrors } from '../lib/configErrors';
import { IConfigIssue, IRoutingConfigVersion } from '../model/types';

export type TPublishResult =
  | { status: 'published'; version: IRoutingConfigVersion }
  | { status: 'failed'; issues: IConfigIssue[] };

// Publish is one POST. The hook keeps the RTK error shape out of the UI by turning
// a failure into path-keyed issues: config paths name the policy / rule the backend
// rejected (a deleted dictionary entry), anything else is one message.
export const usePublishVersion = () => {
  const [publish, { isLoading }] = usePublishRoutingConfigVersionMutation();

  const publishVersion = async (id: number, comment: string): Promise<TPublishResult> => {
    try {
      const published = await publish({ id, body: { comment: comment.trim() } }).unwrap();

      return { status: 'published', version: published.data };
    } catch (error) {
      return { status: 'failed', issues: parseConfigPathErrors(error, GENERIC_PUBLISH_ERROR) };
    }
  };

  return { publishVersion, isPublishing: isLoading };
};
